module.exports = __webpack_public_path__ + "static/media/entities.535c35b7.svg";